export interface Score {
  value: number;
  min?: 0;
  max?: 5;
}

export const MAX_SCORE = 10;

export const scoreToStars = (value: number) => {
  return '⭐️'.repeat(Math.ceil(value / 2));
};
